export default {
    forum_management: '论坛管理',
    tool_management: '工具管理',
    user_management: '用户管理',
    ticket_management: '门票管理',
    order_management: '订单管理',
    website_configuration: '网站配置',
    title: '会议标题11',
    welcome: '欢迎登录{name}会议后台管理',
    count_total: '销售数量统计',
    sales_number: '销售数量',
    money_total: '销售金额统计',
    noAuth_title: '您访问的网页无权限',
    noAuth_subtitle: '对不起, 当前页面您无权限或者路由错误',
    no_exist_title: '您访问的网页无权限或者页面不存在',
    no_sub_title: '对不起, 当前页面您无权限或者路由错误',
    back_home: '返回首页',
    tips: '提示',
    ok: '确定',
    cancel: '取消',
    unknown: '未知',
    confirm_delete_data: '确定删除该条数据吗？',
    actions: '操作',
    pagination_total: '共{value}条',
    delete_success: '删除成功',
    delete_fail: '删除失败',
    copy_link: '复制链接',
    copy: '复制',
    edit: '编辑',
    new: '新增',
    add: '添加',
    delete: '删除',
    operate_scuuess: '操作成功',
    operate_fail: '操作失败',
    confirm_delete: '确认删除',
    copy_success: '复制成功',
    query: '查询',
    open: '开启',
    close: '关闭',
    modify_success: '修改成功',
    add_success: '添加成功',
    search: '搜索',
    show: '显示',
    hide: '隐藏',
    modify: '修改',
    status: '状态',
    index: '序号',
    selected: '选中',
    desc: '说明',
    keyword: '关键字',
    no_dev: '暂未开发',
    date: '日期',
    create_time: '创建时间',
    user_name: '用户姓名',
    mobile: '手机号码',
    order: '订单编号',
    both: '全部',
    details: '详情',
    submit_time: '提交时间',
    cn: '中文',
    en: '英文',
    list: '列表',
    mobile_name: '手机号/姓名',
    company: '单位',
    name: '姓名',
    department: '科室',
    select_at_least_one: '请至少选中一条数据',
    default_text: '默认',
    no_show: '不显示',
    cn_en: '中英文',
    sort: '排序',
    time: '时间',
    clear: '清除',
    class_name: '分类',
    un_select_del: '您还未选中要删除项',
    del_selected: '您确认要删除选中的吗？',
    cannot_back: '被删除的数据将无法找回！',
    first: '第',
    the_session: '届',
    del_current: '确认删除该项吗？',
    save: '保存',
    cn_people: '中宾',
    en_people: '外宾',
    submit: '提交',
    upload: '上传',
    update_success: '更新成功',
    seat_system: '嘉宾排座系统',
    sign_in_system: '现场签到系统',
    survey_system: '问卷调查',
    upload_fail: '上传失败，图片大小不超过5M',
    upload_error: '上传出错',
    placeholder: '请输入内容...',
    content_length_limit: '内容不能超过{length}个字符',
    total: '总计',
    selected: '已选择:',
    word_count: '字数统计：',
    word_count_limit: '单词统计：',
    word_count_limit_max: '字数限制：',
    content_length_limit_max: '内容不能超过{maxLength}个字符',
    email: '邮箱',
    click_download: '点击下载',
    get_verification_code: '获取验证码',
    please_fill_in_the_required_fields: '请填写必填项',
    the_selected_number_cannot_exceed: '选择的数量不能超过{count}条',
    seconds_later_resend: '{seconds}秒后重发',
    country: '所属国家',
    province: '所属省份',
    city: '所属城市',
    district: '所属地区',
    is_key_value: '是否为键值对',
    add_option: '添加选项',
    min_count: '最小条数为{min}条',
    teaching_title: '技术职称',
    download_file: '下载文件',
    download_template: '下载模板',
    upload_success: '上传成功',
    upload_failed: '上传失败',
    download_center: '下载任务中心',
    downloading: '下载中',
    download: '下载',
    download_columns: {
        name: '名称',
        status: '文件状态',
        error_msg: '错误信息',
        time: '创建时间',
        file_size: '文件大小',
        action: '操作'
    },
    download_center_title: '任务中心下载',
    unknown_problem: '未知问题',
    identity_verification_failed: '身份验证失败',
    page_not_found: '您访问的网页不存在。',
    data_loading_error: '数据加载出错',
    new_version_detected: '已检测到系统已更新，2s后自动为您切换到最新版本',
    foreign_identity: '外宾身份',
    domestic_identity: '中宾身份',
    delete_banner: '确定删除该banner吗？',
    clear_success: '清除成功',
    delete_column: '确定删除该栏目吗？',
    not_approve_type: '暂不支持此类型'
};
